import * as React from 'react';

import { Button, Dialog, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/slack-account-link';

type Props = {
  onCancel: () => void;
  onConfirm: () => void;
};

export const UnlinkSlackConfirm = ({ onCancel, onConfirm }: Props) => {
  return (
    <React.Fragment>
      <Dialog.HeadingGroup>{_t('Unlink Slack from Coursera')}</Dialog.HeadingGroup>
      <Dialog.Content id="dialog-content">
        <Typography2 component="p">
          {_t('If you unlink your email, learners can no longer find your Slack account on Coursera.')}
        </Typography2>
      </Dialog.Content>
      <Dialog.Actions>
        <Button variant="secondary" onClick={onCancel} style={{ marginRight: 12 }}>
          {_t('Cancel')}
        </Button>
        <Button data-testid="unlink-confirm-button" variant="primary" onClick={onConfirm}>
          {_t('Unlink')}
        </Button>
      </Dialog.Actions>
    </React.Fragment>
  );
};

export default UnlinkSlackConfirm;
